import { CheckCircle2, Share2 } from "lucide-react";

export const NET_META = {
  facebook: { label: "Facebook", cls: "bg-[#1877F2]" },
  groupes: { label: "Groupes", cls: "bg-slate-700" },
  whatsapp: { label: "WhatsApp", cls: "bg-green-600" },
  linkedin: { label: "LinkedIn", cls: "bg-[#0A66C2]" },
};

const fmt = (iso) => {
  try { return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return ""; }
};

export function SocialPublishBadge({ socialPosts, socialCounts, testid }) {
  const posts = socialPosts || {};
  const counts = socialCounts || {};
  const nets = Object.keys(NET_META).filter((n) => posts[n] || counts[n]);
  if (nets.length === 0) {
    return (
      <span data-testid={testid ? `${testid}-none` : undefined}
        className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-slate-100 text-slate-400 text-[10px] font-semibold">
        Non publiée
      </span>
    );
  }
  const total = nets.reduce((s, n) => s + (counts[n] || 0), 0);
  return (
    <span className="inline-flex items-center gap-1 flex-wrap" data-testid={testid ? `${testid}-done` : undefined}>
      <CheckCircle2 size={13} className="text-emerald-600 shrink-0" />
      {nets.map((n) => {
        const c = counts[n] || 0;
        return (
          <span key={n} title={`${NET_META[n].label} : partagé ${c || 1} fois${posts[n] ? ` · dernier le ${fmt(posts[n])}` : ""}`}
            className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-white text-[10px] font-bold ${NET_META[n].cls}`}>
            {NET_META[n].label}{c > 1 ? ` ×${c}` : ""}
          </span>
        );
      })}
      {total > 0 && (
        <span title={`${total} partage(s) au total`}
          className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded bg-slate-100 text-slate-600 text-[10px] font-bold">
          <Share2 size={10} /> {total}
        </span>
      )}
    </span>
  );
}
